import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiLinks } from '@cutting/app.api-links';
import { CuttingPaymentData, CuttingPaymentResponseDto, CuttingPaySystemInfo } from 'cloud-shared-lib';

@Injectable()
export class PaymentsService {
  constructor(private http: HttpClient) {}

  public getPaySystemsInfo(): Promise<CuttingPaySystemInfo[]> {
    return new Promise((resolve, reject) => {
      this.http.get(ApiLinks.avaliablePaySystems, {}).subscribe((response: CuttingPaySystemInfo[]) => {
        resolve(response);
      }, reject);
    });
  }

  getPSBPaymentParams(data: CuttingPaymentData): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post<CuttingPaymentResponseDto>(ApiLinks.psbPay, data)
        .subscribe((response: CuttingPaymentResponseDto) => {
          resolve(response);
        }, reject);
    });
  }

  getPayPalPaymentParams(data: CuttingPaymentData): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post<CuttingPaymentResponseDto>(ApiLinks.payPalPay, data)
        .subscribe((response: CuttingPaymentResponseDto) => {
          resolve(response);
        }, reject);
    });
  }

  getWooppayPaymentParams(data: CuttingPaymentData): Promise<CuttingPaymentResponseDto> {
    return new Promise((resolve, reject) => {
      this.http
        .post<CuttingPaymentResponseDto>(ApiLinks.wooppayPay, data)
        .subscribe((response: CuttingPaymentResponseDto) => {
          resolve(response);
        }, reject);
    });
  }
}
